var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{class:_vm.itemClass(_vm.item),attrs:{"href":_vm.itemLink(_vm.item),"data-id":_vm.item.id}},[_c('i',{staticClass:"material-icons"},[_vm._v(_vm._s(_vm.learning_unit_icons[_vm.item.type]))]),_vm._v(" "),_c('div',{staticClass:"trax-top-left-icon"},[(_vm.item.meta.remedial)?_c('i',{staticClass:"material-icons"},[_vm._v("replay")]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }